import React, { useCallback, useEffect, useState } from "react";

import { useAuth } from "../../Store/AuthContext";
import axios from "axios";
import ProjectSectionBox from "./ProjectSectionBox";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "admin/API/";

export default function ProjectSectionHome() {
  const { RendomTokenfetch } = useAuth();
  const [CatprojectData, setCatprojectData] = useState([]);
  // console.log(CatprojectData);
  const [loading, setLoading] = useState(false);

  const FetchProjectData = useCallback(async () => {
    setLoading(true);
    try {
      await axios
        .get(`${WebsiteAPIurl}projectsHomeAPI.php`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        })
        .then((response) => {
          // console.log(response.data);
          if (response.data.status === "1") {
            setCatprojectData(response.data.projectdata);
          }
          if (response.data.status === "0") {
            setCatprojectData([]);
          }
        });
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch]);

  useEffect(() => {
    FetchProjectData();
  }, [FetchProjectData]);

  if (loading) {
    // return <APIDataFetchLoader />;
  }

  return (
    <>
      <section className="project-section fix section-padding  section-bg pb-0">
        <div className="container">
          {loading ? (
            <p className="text-center">Loading Projects...</p>
          ) : CatprojectData.length > 0 ? (
            CatprojectData.map((val, index) => (
              <ProjectSectionBox key={index} ProjectData={val} />
            ))
          ) : (
            ""
          )}
        </div>
      </section>
    </>
  );
}
